import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { VentasService } from '../../services/ventas.service';
import { PaginadorService } from '../../paginador/paginador.service';
import pageSettings from '../../config/page-settings';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Venta } from '../../models/ventas.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VentasNewComponent } from './ventas-new.component';
import Swal from 'sweetalert2';
import * as moment from 'moment';

@Component({
  selector: 'app-ventas',
  templateUrl: './ventas.component.html',
  encapsulation: ViewEncapsulation.None,
  styles: []
})
export class VentasComponent implements OnInit {

  pageSettings = pageSettings;
  data_list = [];
  items = [1 , 2, 3, 4];
  buscando: boolean = false;
  frmBuscar: FormGroup;

  constructor(
    private _serviceVentas: VentasService,
    private _servicePaginador: PaginadorService,
    private fb: FormBuilder,
    private modalService: NgbModal
    ) { 
      this.pageSettings.pageWithoutSidebar = false;
      this.pageSettings.pageTopMenu = false;
    }

  ngOnInit() {
    this.buscando = false;
    this.frmBuscar = this.fb.group({
      _txtBuscar: ['']
    });
   this.getLista('1', '10');
  }

  getLista(pagina: string, limit: string) {
    this._serviceVentas.get_listar(pagina, limit).subscribe((resp: any) => {
      this.data_list = resp.data;
      this._servicePaginador.page$.emit(pagina);
      this._servicePaginador.registros$.emit(resp.registros);
    });
  }

  getBuscar(pagina: string, limit: string, buscar: string) {
    this.buscando = true;
    this._serviceVentas.get_buscar(pagina, limit, buscar).subscribe((resp: any) => {
      this.data_list = resp.data;
      this._servicePaginador.page$.emit(pagina);
      this._servicePaginador.registros$.emit(resp.registros);
    });
  }

  receiveMessage($event: any) {
    if (this.frmBuscar.controls._txtBuscar.value === '') {
      this.buscando = false;
    }

    if (!this.buscando)
    {
      this.getLista($event.pagina, $event.recxpag);
    } 

    if (this.buscando)
    {
      const value = this.frmBuscar.controls._txtBuscar.value;
      this.getBuscar($event.pagina, $event.recxpag, value);
    } 

  }

  new (model: Venta) {
    const ref = this.modalService.open(VentasNewComponent, { centered: true, size: 'lg', backdrop: 'static'});
    ref.componentInstance._model = model;
    ref.componentInstance.isEdit = false;
    ref.result.then((data) => {
      if (data.valido) {
        this._serviceVentas.create(data.frm).subscribe((resp: any) => {
          if (resp.data === 'ok') {
            this.getLista('1', '10');
          }
          else {
            Swal.fire("Atención", resp.data, "error");
          }

        });
      }
      else {
        Swal.fire("Atención", "Los datos no son válidos", "error");
      }
    }, (cancel) => {

      });

  }

  Buscar() {
    const value = this.frmBuscar.controls._txtBuscar.value;
    if (value.length > 0) {
      this.buscando = true;
      this.getBuscar('1', '10', value);
    }
    else {
      this.getLista('1', '10');
    }
  }

  edit (model: Venta) {
    const ref = this.modalService.open(VentasNewComponent, { centered: true, size: <any>'xl', backdrop: 'static'});
    ref.componentInstance._model = model;
    ref.componentInstance.isEdit = true;
    ref.componentInstance._cliente = model.cliente_nombre;
    ref.result.then((data) => {
      console.log("data.frm.fecha_venta ==> ", data.frm.fecha_venta);
      if (data.valido) {
        const fechaventa = moment(data.frm.fecha_venta);
        data.frm.fecha_venta = fechaventa;
        this._serviceVentas.update(model.venta_id.toString(), data.frm).subscribe((resp: any) => {
          if (resp.data === 'ok') {
            this.getLista('1', '10');
          }
          else {
            Swal.fire("Atención", resp.msg, "error");
          }

        });
      }
      else {
        Swal.fire("Atención", "Los datos no son válidos", "error");
      }
    }, (cancel) => {

      });


  }

  delete(model: Venta) {
     Swal.fire({
      title: '<span style="font-size: 20px;"> Seguro de eliminar el registro?</span>',
      html: '<p><b>Venta No.:</b> ' + model.numero_recibo + '</p>',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this._serviceVentas.getdelete(model.venta_id.toString()).subscribe((resp: any) => {
          console.log("resp: ", resp);
          if (resp.data === 'ok') {
            this.getLista('1', '10');
            Swal.fire('Información', 'El registro ha sido eliminado...', 'success');
          }
          else {
            Swal.fire('Atención', resp.msg, 'warning');
          }
        });
      } 
    });
  }

}
